/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        url: "https://dev-dc.vlinder.io/vlinder-core/",
      },
    ],
    rest: {
      loginServer: {
        baseURL: "https://dev-dc.vlinder.io/vlinder-login/",
      },
      coreServer: {
        baseURL: "https://dev-dc.vlinder.io/vlinder-core/",
      },
    },
  },
  defaultLoading: {
    image:
      "https://s3.ap-south-1.amazonaws.com/io.klefki.dsci/dsci-logo-dark.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "Holder",
      holders: "Holders",
      issuer: "Organization",
    },
    Holders: {
      title: "Holders",
    },
    HoldersGroups: {
      title: "Holders Group",
    },
    DashboardIssuerAnalysis: {
      title: "Organization",
    },
  },
};
